<template>
	<div class="container_box">
	  <div class="wscn-http404-container">
		 <div class="wscn-http404">
			<div class="pic-404">
			  <img class="pic-404__parent" src="@/assets/404_images/404.png" alt="404">
			  <img class="pic-404__child left" src="@/assets/404_images/404_cloud.png" alt="404">
			  <img class="pic-404__child mid" src="@/assets/404_images/404_cloud.png" alt="404">
			  <img class="pic-404__child right" src="@/assets/404_images/404_cloud.png" alt="404">
			</div>
			<div class="bullshit">
			  <div class="bullshit__oops">哎呀!</div>
			  <!-- <div class="bullshit__info">保留所有权利
				 <a style="color:#20a0ff" href="https://wallstreetcn.com" target="_blank">wallstreetcn</a>
			  </div> -->
			  <div class="bullshit__headline">{{ message }}</div>
			  <div class="bullshit__info">请检查您输入的URL是否正确，或者单击下面的按钮返回主页</div>
			  <a href="/" class="bullshit__return-home">返回主页</a>
			</div>
		 </div>
	  </div>
   </div>
</template>

<script>

export default {
  name: 'Page404',
  computed: {
    message() {
      return '您好，您访问的页面不存在 . . .'
    }
  }
}
</script>

<style lang="less" scoped>
.container_box{
	width: 100%;
	max-width: 100vw;
	height: 100%;
	min-height: 100vh;
	box-sizing: border-box;
	background-color: #000000;
	padding: 15px 15px;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #ffffff;
	overflow: hidden;
}
.wscn-http404-container{
	
}
.wscn-http404 {
  position: relative;
  max-width: 1000px;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  .pic-404 {
    position: relative;
	 max-width: 500px;
	 width: 100%;
    overflow: hidden;
    &__parent {
      width: 100%;
		max-width: 500px;
    }
    &__child {
      position: absolute;
      &.left {
        width: 80px;
        top: 17px;
        left: 220px;
        opacity: 0;
        animation-name: cloudLeft;
        animation-duration: 2s;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
        animation-delay: 1s;
        animation-iteration-count: infinite;
      }
      &.mid {
        width: 46px;
        top: 10px;
        left: 420px;
        opacity: 0;
        animation-name: cloudMid;
        animation-duration: 2s;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
        animation-delay: 1.2s;
        animation-iteration-count: infinite;
      }
      &.right {
        width: 62px;
        top: 100px;
        left: 500px;
        opacity: 0;
        animation-name: cloudRight;
        animation-duration: 2s;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
        animation-delay: 1s;
        animation-iteration-count: infinite;
      }
      @keyframes cloudLeft {
        0% {
          top: 17px;
          left: 220px;
          opacity: 0;
        }
        20% {
          top: 33px;
          left: 188px;
          opacity: 1;
        }
        80% {
          top: 81px;
          left: 92px;
          opacity: 1;
        }
        100% {
          top: 97px;
          left: 60px;
          opacity: 0;
        }
      }
      @keyframes cloudMid {
        0% {
          top: 10px;
          left: 420px;
          opacity: 0;
        }
        20% {
          top: 40px;
          left: 360px;
          opacity: 1;
        }
        70% {
          top: 130px;
          left: 180px;
          opacity: 1;
        }
        100% {
          top: 160px;
          left: 120px;
          opacity: 0;
        }
      }
      @keyframes cloudRight {
        0% {
          top: 100px;
          left: 500px;
          opacity: 0;
        }
        20% {
          top: 120px;
          left: 460px;
          opacity: 1;
        }
        80% {
          top: 180px;
          left: 340px;
          opacity: 1;
        }
        100% {
          top: 200px;
          left: 300px;
          opacity: 0;
        }
      }
    }
  }
  .bullshit {
    position: relative;
	 width: 100%;
    max-width: 400px;
    padding: 0px 0;
    overflow: hidden;
    &__oops {
      font-size: 20px;
      font-weight: bold;
      line-height: 1.5;
      color: #1482f0;
      opacity: 0;
      margin-bottom: 20px;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-fill-mode: forwards;
    }
    &__headline {
      margin-top: 20px;
      font-size: 16px;
      line-height: 1.5;
      color: #f5f5f5;
      font-weight: bold;
      opacity: 0;
      margin-bottom: 10px;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.1s;
      animation-fill-mode: forwards;
    }
    &__info {
      margin-top: 20px;
      font-size: 12px;
      line-height: 1.5;
      color: #ffffff;
      opacity: 0;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.2s;
      animation-fill-mode: forwards;
    }
    &__return-home {
      display: block;
    	padding: 10px 20px;
		max-width: 200px;
      background: #1482f0;
      border-radius: 100px;
    	margin: auto;
      margin-top: 50px;
      text-align: center;
      color: #ffffff;
      opacity: 0;
      font-size: 13px;
      cursor: pointer;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.3s;
      animation-fill-mode: forwards;
    }
    @keyframes slideUp {
      0% {
        transform: translateY(60px);
        opacity: 0;
      }
      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
}
@media only screen and (min-width: 1000px){
	.wscn-http404 {
	  display: flex;
	}
	.bullshit {
		margin-left: 40px;
	}
}
@media only screen and (max-width: 1000px){
	.wscn-http404 {
  	  display: flex;
	  flex-direction: column;
	}
	.bullshit {
		margin-top: 40px;
	}
}
</style>
